import PropTypes from "prop-types";
import React from "react";
import {withNamespaces} from "react-i18next";
import InputGroup from "../../../forms/components/InputGroup/InputGroup";

const CreditCardFormComponent = withNamespaces()((props) => {
  const { t } = props;
  const [showCreditCardNumber, setShowCreditCardNumber] = React.useState(false);
  const [showCvv, setShowCvv] = React.useState(false);

  return (
    <div className="form-group form-group-col">
      <div className="form-group">
        <InputGroup id="credit_card_number"
                    topLabel={true}
                    label={t('card_form_credit_card_number')}
                    error={props.errors.credit_card_number}>
          <input type={showCreditCardNumber ? "text" : "password"}
                 id="credit_card_number"
                 autoComplete={"off"}
                 value={props.card.credit_card_number}
                 onChange={(e) => props.onChange('credit_card_number', e.target.value)}
                 placeholder={t('card_form_credit_card_number')}
          />
          <a className="show-password" onClick={() => setShowCreditCardNumber(!showCreditCardNumber)}>
            {showCreditCardNumber ?
              (<i className="fa fa-eye" alt="password eye"/>) :
              (<i className="fa fa-eye-slash" alt="password eye"/>)
            }
          </a>
        </InputGroup>
      </div>

      <div className="form-group">
        <InputGroup id="credit_card_name"
                    topLabel={true}
                    label={t('card_form_credit_card_name')}
                    error={props.errors.credit_card_name}>
          <input type="text"
                 id="credit_card_name"
                 value={props.card.credit_card_name}
                 onChange={(e) => props.onChange('credit_card_name', e.target.value)}
                 placeholder={t('card_form_credit_card_name')}
          />
        </InputGroup>
      </div>

      <div className="form-group">
        <InputGroup id="credit_card_exp_month"
                    topLabel={true}
                    label={t('card_form_credit_card_exp_month')}
                    error={props.errors.credit_card_exp_month}>
          <input type="number"
                 id="credit_card_exp_month"
                 value={props.card.credit_card_exp_month}
                 onChange={(e) => props.onChange('credit_card_exp_month', e.target.value)}
                 placeholder={t('card_form_credit_card_exp_month')}
          />
        </InputGroup>

        <InputGroup id="credit_card_exp_year"
                    topLabel={true}
                    label={t('card_form_credit_card_exp_year')}
                    error={props.errors.credit_card_exp_year}>
          <input type="number"
                 id="credit_card_exp_year"
                 value={props.card.credit_card_exp_year}
                 onChange={(e) => props.onChange('credit_card_exp_year', e.target.value)}
                 placeholder={t('card_form_credit_card_exp_year')}
          />
        </InputGroup>
        <InputGroup id="credit_card_cvv"
                    topLabel={true}
                    label={t('card_form_credit_card_cvv')}
                    error={props.errors.credit_card_cvv}>
          <input type={showCvv ? "text" : "password"}
                 id="credit_card_cvv"
                 value={props.card.credit_card_cvv}
                 autoComplete={"off"}
                 onChange={(e) => props.onChange('credit_card_cvv', e.target.value)}
                 placeholder={t('card_form_credit_card_cvv')}
          />
          <a className="show-password" onClick={() => setShowCvv(!showCvv)}>
            {showCvv ?
              (<i className="fa fa-eye" alt="password eye"/>) :
              (<i className="fa fa-eye-slash" alt="password eye"/>)
            }
          </a>
        </InputGroup>
      </div>
    </div>
  );
});
CreditCardFormComponent.propTypes = {
  card: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object
};
export default CreditCardFormComponent;